<template>
  <div>
    <div class="card">
      <div class="card__header">
        <h2>
          Coupon application
          <small>Total coupon: {{ couponCodes.total }}</small>
        </h2>

        <div class="actions">
          <el-dropdown @command="(to) => $router.push(to)">
            <span class="el-dropdown-link">
              <i class="el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/export-coupon-report">Export Reports</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>


      <div class="flot-chart-edge">
        <div id="chart-curved-line" class="flot-chart">
          <div class="card__body">
            <el-row :gutter="20">
              <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="2">
                <router-link to="/coupon-create">
                  <el-button type="warning" size="small">Create Coupon</el-button>
                </router-link>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="3">
                <el-input
                    type="text"
                    size="small"
                    v-model="keyword"
                    class="form-control"
                    placeholder="Search coupon code here......"
                    id="search"
                    name="search"
                    @keyup.enter.native="searchCoupon()"
                >
                </el-input>
              </el-col>
              <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="3">
                <el-button type="success" size="small" @click="searchCoupon()" icon="el-icon-search">Search</el-button>
                <el-button type="default" size="small" @click="resetAll()">Reset All</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :xs="12" :sm="12" :md="6" :lg="4" :xl="3">
                <el-select
                    v-model="countryFilter"
                    placeholder="Country Filter"
                    class="form-control form-control"
                    id="countryFilter"
                    name="countryFilter"
                    @change="searchCoupon()"
                    clearable
                    size="small"
                >
                  <el-option
                      v-for="item in countryFilterItems"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :xs="12" :sm="12" :md="6" :lg="4" :xl="3">
                <el-select
                    v-model="couponGroupFilter"
                    placeholder="Group Filter"
                    class="form-control form-control"
                    id="couponGroupFilter"
                    name="couponGroupFilter"
                    @change="searchCoupon()"
                    clearable
                    size="small"
                >
                  <el-option
                      v-for="item in couponGroupFilterItems"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :xs="12" :sm="12" :md="6" :lg="4" :xl="3">
                <el-select
                    v-model="couponTypeFilter"
                    placeholder="Type Filter"
                    class="form-control form-control"
                    id="couponTypeFilter"
                    name="couponTypeFilter"
                    @change="searchCoupon()"
                    clearable
                    size="small"
                >
                  <el-option
                      v-for="item in couponTypeFilterItems"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :xs="12" :sm="12" :md="6" :lg="4" :xl="3">
                <el-select
                    v-model="statusFilter"
                    placeholder="Status Filter"
                    class="form-control form-control"
                    id="statusFilter"
                    name="statusFilter"
                    @change="searchCoupon()"
                    clearable
                    size="small"
                >
                  <el-option
                      v-for="item in statusFilterItems"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>

            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                  <tr>
                    <th>Link</th>
                    <th>Country</th>
                    <th>Group</th>
                    <th>Group Detail</th>
                    <th>Code</th>
                    <th>Type</th>
                    <th v-model="sortByAmount">
                      <a
                          class="column-header-anchor"
                          style="cursor: pointer;"
                          @click="clickSortByAmount()"
                      >
                        <span class="text">Amount</span>&emsp;
                        <span class="sort-by-amount-icon glyphicon"></span>
                      </a>
                    </th>
                    <th>Family</th>
                    <th v-model="sortBySize">
                      <a
                          class="column-header-anchor"
                          style="cursor: pointer;"
                          @click="clickSortBySize()"
                      >
                        <span class="text">Size</span>&emsp;
                        <span class="sort-by-size-icon glyphicon"></span>
                      </a>
                    </th>
                    <th>Factory</th>
                    <th>Source</th>
                    <th>Retailer Name</th>
                    <th>Authorized Reseller</th>
                    <th>SKU</th>
                    <th>Customer name</th>
                    <th>Customer email</th>
                    <th>Customer phone</th>
                    <th>Order number</th>
                    <th>Additional</th>
                    <th>Status</th>
                    <th>Img</th>
                    <th>Created by</th>
                    <th v-model="sortByUpdatedAt">
                      <a
                          class="column-header-anchor"
                          style="cursor: pointer;"
                          @click="clickSortByUpdatedAt()"
                      >
                        <span class="text">Updated at</span>&emsp;
                        <span class="sort-by-update-at-icon glyphicon"></span>
                      </a>
                    </th>
                    <th>Expired at</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="couponCode in couponCodes.data">
                    <td>
                      <router-link
                          :to="{ name: 'coupon-create', query: {id: couponCode.id}}"
                      >Edit Code
                      </router-link>
                    </td>
                    <td>{{ couponCode.country }}</td>
                    <td>{{ couponCode.group_name }}</td>
                    <td>{{ couponCode.group_detail }}</td>
                    <td>{{ couponCode.code }}</td>
                    <td>{{ couponCode.type }}</td>
                    <td>{{ couponCode.amount }}</td>
                    <td>{{ couponCode.code_type }}</td>
                    <td>{{ couponCode.size }}</td>
                    <td>{{ couponCode.factory }}</td>
                    <td>{{ couponCode.supplier }}</td>
                    <td>{{ couponCode.retailer_name }}</td>
                    <td>{{ couponCode.authorized_reseller }}</td>
                    <td>{{ couponCode.product_sku }}</td>
                    <td>{{ couponCode.customer_first_name }} {{ couponCode.customer_last_name }}</td>
                    <td>{{ couponCode.customer_email }}</td>
                    <td>{{ couponCode.customer_phone }}</td>
                    <td>{{ couponCode.order_number }}</td>
                    <td>{{ couponCode.reason }}</td>
                    <td>{{ couponCode.status }}</td>
                    <td>
                      <div v-if="couponCode.img_url !== ''">
                        <a v-bind:href="couponCode.img_url" target="_blank">
                          <img v-bind:src="couponCode.img_url" height="42" width="42"/>
                        </a>
                      </div>
                    </td>
                    <td>{{ couponCode.created_by }}</td>
                    <td>{{ couponCode.updated_at }}</td>
                    <td>{{ couponCode.expired_at }}</td>
                    <td>
                      <div v-if="couponCode.status === 'pending'">
                        <button
                            class="btn btn-success"
                            @click="couponAction(couponCode.id,1)"
                        >Approve
                        </button>
                        <button
                            class="btn btn-danger"
                            @click="couponAction(couponCode.id,2)"
                        >Decline
                        </button>
                      </div>

                      <div v-if="couponCode.status === 'approved' ">
                        <button class="btn btn-danger" @click="trashCoupon(couponCode.id)">Trash</button>
                        <button
                            class="btn btn-warning"
                            @click="couponAction(couponCode.id,4)"
                        >Cancel
                        </button>
                        <button class="btn" @click="copy(couponCode.id)">Copy</button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <pagination-navigation
                v-on:pageChange="getCouponCodes"
                :pagination="couponCodes"
                :navigation="navigation"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {notify} from "../../utils";
import axios, {RepositoryError} from "../../repositories";
import PaginationNavigation from "../common/PaginationNavigation";

export default {
  components: {
    PaginationNavigation
  },
  mounted() {
    this.getCouponCodes();
    this.getCouponConfig();
  },
  data() {
    return {
      couponCodes: {
        current_page: 0,
        data: [],
        first_page_url: "",
        from: 0,
        last_page: 0,
        last_page_url: "",
        next_page_url: "",
        path: "",
        per_page: 0,
        prev_page_url: null,
        to: 0,
        total: 0
      },
      navigation: {
        numLinks: 9
      },
      couponCodeCount: 0,
      couponGroupFilterItems: [],
      couponGroupFilter: "",
      couponTypeFilterItems: [
        {
          value: "fixed",
          label: "Fixed"
        },
        {
          value: "percentage",
          label: "Percentage"
        }
      ],
      couponTypeFilter: "",
      countryFilterItems: [
        {
          value: "usa",
          label: "United States"
        },
        {
          value: "ca",
          label: "Canada"
        },
      ],
      countryFilter: "",
      statusFilterItems: [
        {
          value: "pending",
          label: "Pending"
        },
        {
          value: "approved",
          label: "Approved"
        },
        {
          value: "declined",
          label: "DeclinedRep"
        },
        {
          value: "trashed",
          label: "Trashed"
        },
        {
          value: "canceled",
          label: "Canceled"
        }
      ],
      statusFilter: "",
      sortByUpdatedAt: "",
      sortBySize: "",
      sortByAmount: "",
      value: "",
      keyword: this.$route.query.search ?? "",
      filterCollection: {},
      sortCollection: {},
      queryString: this.$route.query.search ?? ""
    };
  },
  methods: {
    clickSortByUpdatedAt() {
      if (
          !$(".sort-by-update-at-icon").hasClass("glyphicon-triangle-bottom") &&
          !$(".sort-by-update-at-icon").hasClass("glyphicon-triangle-top")
      ) {
        $(".sort-by-update-at-icon").addClass("glyphicon-triangle-bottom");
        this.sortByUpdatedAt = "desc";
      } else if (
          $(".sort-by-update-at-icon").hasClass("glyphicon-triangle-bottom")
      ) {
        $(".sort-by-update-at-icon").removeClass("glyphicon-triangle-bottom");
        $(".sort-by-update-at-icon").addClass("glyphicon-triangle-top");
        this.sortByUpdatedAt = "asc";
      } else if (
          $(".sort-by-update-at-icon").hasClass("glyphicon-triangle-top")
      ) {
        $(".sort-by-update-at-icon").removeClass("glyphicon-triangle-top");
        this.sortByUpdatedAt = "";
      }
      this.searchCoupon();
    },
    clickSortBySize() {
      if (
          !$(".sort-by-size-icon").hasClass("glyphicon-triangle-bottom") &&
          !$(".sort-by-size-icon").hasClass("glyphicon-triangle-top")
      ) {
        $(".sort-by-size-icon").addClass("glyphicon-triangle-bottom");
        this.sortBySize = "desc";
      } else if (
          $(".sort-by-size-icon").hasClass("glyphicon-triangle-bottom")
      ) {
        $(".sort-by-size-icon").removeClass("glyphicon-triangle-bottom");
        $(".sort-by-size-icon").addClass("glyphicon-triangle-top");
        this.sortBySize = "asc";
      } else if ($(".sort-by-size-icon").hasClass("glyphicon-triangle-top")) {
        $(".sort-by-size-icon").removeClass("glyphicon-triangle-top");
        this.sortBySize = "";
      }
      this.searchCoupon();
    },
    clickSortByAmount() {
      if (
          !$(".sort-by-amount-icon").hasClass("glyphicon-triangle-bottom") &&
          !$(".sort-by-amount-icon").hasClass("glyphicon-triangle-top")
      ) {
        $(".sort-by-amount-icon").addClass("glyphicon-triangle-bottom");
        this.sortByAmount = "desc";
      } else if (
          $(".sort-by-amount-icon").hasClass("glyphicon-triangle-bottom")
      ) {
        $(".sort-by-amount-icon").removeClass("glyphicon-triangle-bottom");
        $(".sort-by-amount-icon").addClass("glyphicon-triangle-top");
        this.sortByAmount = "asc";
      } else if ($(".sort-by-amount-icon").hasClass("glyphicon-triangle-top")) {
        $(".sort-by-amount-icon").removeClass("glyphicon-triangle-top");
        this.sortByAmount = "";
      }
      this.searchCoupon();
    },
    searchCoupon() {
      this.queryString = this.keyword.trim();

      if (this.couponGroupFilter !== "") {
        this.filterCollection["group_name"] = this.couponGroupFilter;
      } else {
        delete this.filterCollection["group_name"];
      }
      if (this.couponTypeFilter !== "") {
        this.filterCollection["type"] = this.couponTypeFilter;
      } else {
        delete this.filterCollection["type"];
      }
      if (this.countryFilter !== "") {
        this.filterCollection["country"] = this.countryFilter;
      } else {
        delete this.filterCollection["country"];
      }
      if (this.statusFilter !== "") {
        this.filterCollection["status"] = this.statusFilter;
      } else {
        delete this.filterCollection["status"];
      }

      if (this.sortByUpdatedAt !== "") {
        this.sortCollection["updated_at"] = this.sortByUpdatedAt;
      } else {
        delete this.sortCollection["updated_at"];
      }
      if (this.sortBySize !== "") {
        this.sortCollection["size"] = this.sortBySize;
      } else {
        delete this.sortCollection["size"];
      }
      if (this.sortByAmount !== "") {
        this.sortCollection["amount"] = this.sortByAmount;
      } else {
        delete this.sortCollection["amount"];
      }

      this.$router.push({ query: { search: this.queryString } })

      this.getCouponCodes();
    },
    resetAll() {
      this.keyword = "";
      (this.countryFilter = ""),
          (this.couponGroupFilter = ""),
          (this.couponTypeFilter = ""),
          (this.statusFilter = ""),
          (this.sortByUpdatedAt = ""),
          (this.sortBySize = ""),
          (this.sortByAmount = ""),
          $(".sort-by-update-at-icon").removeClass(
              "glyphicon-triangle-bottom glyphicon-triangle-top"
          );
      $(".sort-by-size-icon").removeClass(
          "glyphicon-triangle-bottom glyphicon-triangle-top"
      );
      $(".sort-by-amount-icon").removeClass(
          "glyphicon-triangle-bottom glyphicon-triangle-top"
      );
      this.searchCoupon();
    },
    async trashCoupon(id) {
      try {
        await this.$confirm(
            "This will permanently delete the coupon. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning"
            }
        );
      } catch {
        // Cancelled
        return;
      }

      try {
        await axios.delete("/discounts/trash-coupon", {
          data: {id}
        });
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      }

      this.getCouponCodes();

      notify("Coupon code has been trashed", "success");
    },
    async couponAction(id, action) {
      // 4 means cancel because yes
      if (action === 4) {
        try {
          await this.$confirm(
              "This will cancel the coupon. Continue?",
              "Warning",
              {
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                type: "warning"
              }
          );
        } catch {
          // Cancelled
          return;
        }
      }

      try {
        const res = await axios.post("/discounts/coupon-action", {id, action});

        this.getCouponCodes();

        notify(res.data.message, "success");
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      }
    },
    copy(id) {
      this.$router.push({
        name: "coupon-copy",
        params: {
          original_id: id
        }
      });
    },
    async getCouponCodes(url = "/discounts/all") {
      try {
        const res = await axios.get(url, {
          params: {
            search: this.queryString,
            filter: this.filterCollection,
            sort: this.sortCollection
          }
        });

        this.couponCodes = res.data;
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      }
    },
    goToEditPage(id) {
      this.$emit("editCouponCode", id);
      this.$router.push({
        name: "coupon-create",
        query: {redirect: "/coupon-create"}
      });
    },
    async getCouponConfig() {
      try {
        const res = await axios.get("/discounts/get-coupon-config");

        this.couponGroupFilterItems = res.data.couponGroup;
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      }
    }
  }
};
</script>
